import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
	password: (field?: any) => [
		validations.required.text(field),
		validations.pattern.password(field),

	],
	password_confirmation: (field?: any) => [
		validations.required.text(field),
		({ getFieldValue }: any) => ({
			validator(_: any, value: string) {
				if (!value || getFieldValue("new_password") === value) {
					return Promise.resolve();
				}
				return Promise.reject("Password does not match.");
			},
		}),
	],
};